<template>
  <div class="report-bug">
    <h1>Report a bug custom button</h1>
    <div class="wrapper">
      <p>
        Edit report a bug button and link. Edit label and URL for button in the
        Report a bug custom bug section.
      </p>
      <div class="top">
        <h2>Enable report a bug</h2>
        <a-switch :checked="data.enabled" @change="$emit('reportBug', {
          key: 'enabled',
          value: $event,
        })" />
      </div>
      <div class="input-wrap">
        <div class="label-wrap">
          <label for="">Input Label</label>
          <span class="material-icons"> help_outline </span>
        </div>
        <a-input :maxLength="255" :value="data.label"  @input="
            $emit('reportBug', {
              key: 'label',
              value: $event.target.value,
            })
          "/>
      </div>
      <div class="navigation-link-input-wrap">
        <div class="label-wrap">
          <label for="">Input Navigation Item URL</label>
          <span class="material-icons"> help_outline </span>
        </div>
        <a-input
          :maxLength="255"
          :addon-before="FOOTER_URL_PREFIX"
          default-value="Nav Url"
          :value="urlPart"
          @input="
            $emit('reportBug', {
              key: 'url',
              value: FOOTER_URL_PREFIX + $event.target.value,
            })
          "
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
export default {
  props: {
    data: {
      type: Object,
    },
  },
  computed: {
    ...mapState(['FOOTER_URL_PREFIX']),
    urlPart () {
      return this.data.url.slice(this.FOOTER_URL_PREFIX.length);
    },
  },
};
</script>

<style scoped lang='scss'>
.report-bug {
  margin: 40px 0 0 0;
  h1 {
    font-family: Roboto;
    font-style: normal;
    font-weight: bold;
    font-size: 18px;
    line-height: 21px;
    color: #001529;
    padding: 25px 0;
    border-bottom: 1px solid #cbcbe4;
  }
  .wrapper {
    max-width: 650px;
    .top {
      display: flex;
      align-items: center;
      justify-content: space-between;
      max-width: 500px;
      h2 {
        font-family: Roboto;
        font-style: normal;
        font-weight: 500;
        font-size: 18px;
        line-height: 21px;
        color: #001529;
        margin: 15px 0;
      }
    }
    p {
      font-family: Roboto;
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 16px;
      color: #001529;
    }
    .material-icons {
      color: #b2bac7;
      font-size: 14px;
      display: inline-block;
      margin: 0 5px;
    }
    .input-wrap {
      display: flex;
      margin: 25px 0;
      .label-wrap {
        display: flex;
        align-items: center;
        justify-content: center;
        label {
          font-family: Roboto;
          font-style: normal;
          font-weight: normal;
          font-size: 14px;
          line-height: 22px;
          color: #001529;
          width: 70px;
        }
      }
    }
    .navigation-link-input-wrap {
      label {
        font-family: Roboto;
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 22px;
        color: #001529;
      }
    }
  }
}
</style>


<style>
/* utility css for inputs bc of ant */
body
  > div
  > div
  > div.footer.admin-page
  > div.content-wrap
  > div.report-bug
  > div
  > div.input-wrap
  > input {
  width: 150px;
  height: 32px;
  background: #ffffff;
  border: 1px solid #dfe1e6;
  box-sizing: border-box;
  border-radius: 2px;
}

body
  > div
  > div
  > div.footer.admin-page
  > div.content-wrap
  > div.report-bug
  > div
  > div.navigation-link-input-wrap
  > span
  > span {
  background: #ffffff;
  box-sizing: border-box;
  border-radius: 0px 2px 2px 0px;
  width: 450px;
}
body
  > div
  > div
  > div.footer.admin-page
  > div.content-wrap
  > div.report-bug
  > div
  > div.navigation-link-input-wrap
  > span
  > span
  > input {
  border-radius: 2px;
}
</style>

